import React from 'react';
import { useThemeContext } from '@crema/context/ThemeContextProvider';
import { alpha, Box, Typography } from '@mui/material';
import { ReactComponent as Logo } from '../../../../assets/new/Sabrhub-logo.svg';
import { ReactComponent as LogoText } from '../../../../assets/new/logo_text_small.svg';
import { useNavigate } from 'react-router-dom';
import {
  useJWTAuth,
  useJWTAuthActions,
} from '@crema/services/auth/JWTAuthProvider';

type AppLogoHorizontalProps = {
  color?: string;
};

const AppLogoHorizontal: React.FC<AppLogoHorizontalProps> = ({ color }) => {
  const { theme } = useThemeContext();
  const navigate = useNavigate();

  const { user, originalUser } = useJWTAuth();
  const { setAuthData } = useJWTAuthActions();

  const goBackHome = () => {
    if (user?.roles?.includes('SUPER_ADMIN') && user.cspUserId) {
      setAuthData({
        user: { ...originalUser },
        isAuthenticated: true,
        isLoading: false,
      });
    }

    navigate(`/`);
  };

  return (
    <div onClick={() => goBackHome()}>
      <Box
        sx={{
          // height: { xs: 56, sm: 70 },
          // padding: 2.5,
          display: 'flex',
          flexDirection: 'row',
          cursor: 'pointer',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': {
            height: { xs: 70, sm: 70 },
          },
        }}
        className="app-logo"
      >
        <Logo />
      </Box>
    </div>
  );
};

export default AppLogoHorizontal;
